import createPageConstants from '../shared/util/createPageConstants';
const pluginId = 'surveys';
export const SurveyConstants = createPageConstants(pluginId, 'Form', {
  defaultDefault: 'surveysListPage',
});
export const SurveyInstanceConstants = createPageConstants(pluginId, 'Form Instance', {
  default: 'surveyInstancesPage',
  editor: 'surveyInstanceEditorPage',
});
